import React from 'react';
import {
  getFileFromServer,
  uploadFileToServer
} from '../../../../services/tm/investigationDetail';
import style from './index.scss';
import { Modal, ModalBody, ModalFooter, Progress } from 'reactstrap';
import classnames from 'classnames';
import TookiTakiRichEditor from './TookitakiRichEditor';
import { connect } from 'react-redux';
import { onSaveNoteFunction } from '../../../../redux/actions/tm/utils';
import {
  getAnalystSupervisorPerms,
  getFileNameAndID
} from './investDetailHeaderUtil';
import Wait4Me from '../../../../components/Wait4Me';
import { getAlertIDFromURL } from '../../../../services/util';
import AlertPopup from '../../../../components/AlertPopup';
import ConfirmationPopup from '../../../../components/ConfirmationPopup';

import { isEmpty } from '../../../../util/lodashlike';
/**
 * EditorModal on investigation header
 */
class EditorModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      editorHTML: null,
      editorText: null,
      selectedFile: null,
      loaded: 0,
      fileID: null,
      onStartUpload: false,
      isDownloading: false,
      showAlertPopUp: false,
      showConfirmationPopup: false,
      alertMsg: '',
      confirmMsg: ''
    };
  }

  /**
   * onChangeHandler
   * @param event
   */
  onChangeHandler = (event) => {
    const uploadedFile = event.target.files[0];
    const fileSize = uploadedFile.size / 1024 / 1024; // in MB
    const allowedExtensions = /(\.doc|\.docx|\.pdf|\.xls|\.xlsx)$/i;
    if (fileSize > 5) {
      this.toggleAlert('File size cannot be greater than 5Mb');
      return;
    }

    if (!allowedExtensions.exec(uploadedFile.name)) {
      this.toggleAlert('Only Word, PDF and Excel files are allowed.');
      return;
    }

    this.setState(
      () => ({
        selectedFile: uploadedFile,
        loaded: 0,
        onStartUpload: true
      }),
      () => {
        const data = new FormData();
        data.append('file', this.state.selectedFile);
        uploadFileToServer(data, this.progressChangeHandler).then((res) => {
          if (res?.data) {
            this.setState({ fileID: res.data });
          }
        });
      }
    );
  };
  onConfirm = () => {
    // do nothing as of now
  };
  /**
   * onEditorChange
   * @param innerHtml
   * @param editorText
   */
  onEditorChange = (innerHtml, editorText) => {
    this.setState({ editorHTML: innerHtml, editorText });
  };
  /**
   * onEditorTextSave
   */
  onEditorTextSave = () => {
    const { supervisorNote = '', investigatorNote = '' } =
      this.props.headerAlertDetailObject || {};
    const { analystEditorModalWidgetPerm, superVisorEditorModalWidgetPerm } =
      this.props;
    const { isSuWrite, isAnWrite } = getAnalystSupervisorPerms(
      analystEditorModalWidgetPerm,
      superVisorEditorModalWidgetPerm
    );
    const { editorHTML, editorText, selectedFile, fileID } = this.state;
    const { alertID } = getAlertIDFromURL();
    if (isEmpty(editorText) && (isSuWrite || isAnWrite)) {
      let note = '';
      if (isSuWrite && !isEmpty(supervisorNote)) {
        note = supervisorNote;
      }
      if (isAnWrite && !isEmpty(investigatorNote)) {
        note = investigatorNote;
      }

      if (isEmpty(note)) {
        this.toggleAlert('Investigation Notes are mandatory for submission.');
        return false;
      }

      this.setState({ editorText: note, editorHTML: note }, () => {
        this.props.onSaveNote({
          alertID: alertID,
          noteDetails: {
            html: this.state.editorHTML,
            text: this.state.editorText,
            file: this.state.selectedFile
          }
        });
        this.props.onEditorTextSubmit(
          this.state.editorHTML,
          this.state.editorText,
          this.state.selectedFile,
          this.state.fileID
        );
        this.setModal(!this.state.modal);
      });
    } else {
      this.props.onSaveNote({
        alertID: alertID,
        noteDetails: {
          html: editorHTML,
          text: editorText,
          file: selectedFile
        }
      });
      this.props.onEditorTextSubmit(
        editorHTML,
        editorText,
        selectedFile,
        fileID
      );
      this.setModal(!this.state.modal);
    }
  };

  onReject = () => {
    this.setState({
      showConfirmationPopup: false,
      confirmMsg: '',
      confirmType: ''
    });
  };

  /**
   * setModal func
   */
  setModal = () => {
    this.setState({ modal: !this.state.modal });
  };

  /**
   * downloadFile
   * @returns {Promise<void>}
   */
  downloadFile = async () => {
    const { isAvailable, attachmentID, attachmentName } = getFileNameAndID(
      this.props,
      this.state
    );
    if (!isAvailable) {
      this.toggleAlert('No file to download');
      return;
    }
    this.setState({ isDownloading: true });
    await getFileFromServer(attachmentID).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.download = attachmentName;
      link.click();
      this.setState({ isDownloading: false });

      //Clean up link.
      window.URL.revokeObjectURL(url);
    });
  };

  /**
   * progressChangeHandler
   * @param ProgressEvent
   */
  progressChangeHandler = (ProgressEvent) => {
    this.setState({
      loaded: (ProgressEvent.loaded / ProgressEvent.total) * 100
    });
  };

  /**
   * toggleAlert Box
   * @param msg
   * @returns {boolean}
   */
  toggleAlert = (msg = '') => {
    this.setState({
      showAlertPopUp: !this.state.showAlertPopUp,
      alertMsg: msg
    });
    return false;
  };
  toggleConfirmation = (msg) => {
    this.setState({
      showConfirmationPopup: !this.state.showConfirmationPopup,
      confirmMsg: msg
    });
    return false;
  };

  /**
   * render func
   * @returns {div}
   */
  render() {
    const {
      className,
      analystEditorModalWidgetPerm,
      superVisorEditorModalWidgetPerm,
      headerAlertDetailObject,
      savedNote
    } = this.props;
    const { modal, isDownloading, fileID, onStartUpload } = this.state;
    const toggle = () => this.setModal(!this.state.modal);
    const { attachmentId } = headerAlertDetailObject;
    const { isAnWrite, isAnHidden, isSuWrite, isSuHidden } =
      getAnalystSupervisorPerms(
        analystEditorModalWidgetPerm,
        superVisorEditorModalWidgetPerm
      );
    if (isSuHidden && isAnHidden) {
      return <div />;
    }

    return (
      <div>
        <a className={style.anomalyActionButton} onClick={toggle}>
          <i className="icon32 icon32_icon_file_edit" />
        </a>
        {this.state.showAlertPopUp && (
          <AlertPopup
            toggleAlert={this.toggleAlert}
            content={this.state.alertMsg}
          />
        )}
        {this.state.showConfirmationPopup && (
          <ConfirmationPopup
            onReject={this.onReject}
            content={this.state.confirmMsg}
            onAccept={this.onConfirm}
          />
        )}
        <Modal
          backdrop="static"
          contentClassName={style.modalClass}
          isOpen={modal}
          toggle={toggle}
          className={className}>
          <div className={classnames(style.tooltip_popup_header)}>
            <span>My Investigation notes</span>
            <button type="button" onClick={toggle}>
              <i className="icon14 icon14_icon_close" />
            </button>
          </div>
          <ModalBody className={style.modalBodyClass}>
            <TookiTakiRichEditor
              savedNote={savedNote}
              headerAlertDetailObject={headerAlertDetailObject}
              analystEditorModalWidgetPerm={analystEditorModalWidgetPerm}
              superVisorEditorModalWidgetPerm={superVisorEditorModalWidgetPerm}
              onEditorTextChange={this.onEditorChange}
            />
          </ModalBody>
          <ModalFooter className={style.modalFooterClass}>
            <div className={style.flexRowSpaceBetween}>
              <div className={style.editorActionButtons}>
                {isAnWrite && (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      marginRight: 8
                    }}>
                    <div className={style.imageUpload}>
                      <label
                        htmlFor="file-input"
                        className={style.downloadLabel}>
                        <i
                          className={classnames(
                            'icon20',
                            'icon20_icon_attachment'
                          )}
                        />
                        <span>Attach Files</span>
                      </label>
                      <input
                        id="file-input"
                        value=""
                        accept=".xlsx,.xls,.doc, .docx,.pdf"
                        type="file"
                        name="file"
                        onChange={this.onChangeHandler}
                      />
                    </div>
                    <div>
                      {onStartUpload && (
                        <Progress
                          max="100"
                          color="success"
                          value={this.state.loaded}>
                          {Math.round(this.state.loaded)}%
                        </Progress>
                      )}
                    </div>
                  </div>
                )}
                {(fileID || attachmentId) && !isDownloading && (
                  <div className={style.imageUpload}>
                    <label className={style.downloadLabel}>
                      <span onClick={this.downloadFile}>
                        <i
                          className={classnames(
                            'icon20',
                            'icon20_icon_download'
                          )}
                        />
                        Download File
                      </span>
                    </label>
                  </div>
                )}
                {isDownloading && (
                  <div className={style.imageUpload}>
                    <Wait4Me />
                  </div>
                )}
              </div>
              {(isAnWrite || isSuWrite) && (
                <button
                  onClick={this.onEditorTextSave}
                  type="button"
                  className={style.editorSaveButton}>
                  Save
                </button>
              )}
            </div>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

/**
 * Get SavedNote from Redux
 * @param state
 * @param ownProps
 * @returns {{savedNote: *}}
 */
function mapStateToProps(state, ownProps = {}) {
  const { utils } = state;
  const { savedNote } = utils;
  return {
    savedNote
  };
}

/**
 * Save SavedNote to Redux
 * @param dispatch
 * @param ownProps
 * @returns {{onSaveNote: onSaveNote, dispatch: *}}
 */
function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    dispatch,
    onSaveNote: (payload) => {
      dispatch(onSaveNoteFunction(payload));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditorModal);
